import React, { createContext, useState } from "react";

import { IProviderProps } from "./interfaces";

export const DarkModeContext = createContext<IDarkModeProvider>({
    darkMode: false,

});
export interface IDarkModeProvider {
    darkMode: boolean;
    toggleDarkMode?: () => void;
}


export const DarkModeProvider = (props: IProviderProps) => {
    // Use State to keep the values
    const [darkMode, setDarkMode] = useState(false);

    const toggleDarkMode = () => {
        console.log("toggleDarkMode")
        setDarkMode(!darkMode);
    };


    // Make the context object:
    const darkModeContext = {
        darkMode: darkMode,
        toggleDarkMode: toggleDarkMode,

    };

    // pass the value in provider and return
    return <DarkModeContext.Provider value={darkModeContext}>{props.children}</DarkModeContext.Provider>;
};










